import {httpAuth} from './config';

export default {
    list: () => {
        return httpAuth.get(`api/external/group/list?system_id=${process.env.VUE_APP_SYSTEM_ID}`);
    },
}